/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { MicrosoftConsumerSecurityClientContext } from "./microsoftConsumerSecurityClientContext";

class MicrosoftConsumerSecurityClient extends MicrosoftConsumerSecurityClientContext {
  // Operation groups
  alerts: operations.Alerts;
  apiVersions: operations.ApiVersions;
  associatedDevices: operations.AssociatedDevices;
  betaEnrollment: operations.BetaEnrollment;
  breaches: operations.Breaches;
  chat: operations.Chat;
  credit: operations.Credit;
  deviceProtectionHistory: operations.DeviceProtectionHistory;
  devices: operations.Devices;
  downloads: operations.Downloads;
  emailVerification: operations.EmailVerification;
  eol: operations.Eol;
  familyBreaches: operations.FamilyBreaches;
  familyCredit: operations.FamilyCredit;
  familyEmailVerification: operations.FamilyEmailVerification;
  familyIdentityTheftMonitoringSubscription: operations.FamilyIdentityTheftMonitoringSubscription;
  familyIdentityTheftMonitoringSubscriptionAuthentication: operations.FamilyIdentityTheftMonitoringSubscriptionAuthentication;
  familyInvitations: operations.FamilyInvitations;
  familyMembers: operations.FamilyMembers;
  familyPermissions: operations.FamilyPermissions;
  familyPhoneVerification: operations.FamilyPhoneVerification;
  familyUser: operations.FamilyUser;
  identityTheftMonitoringSubscription: operations.IdentityTheftMonitoringSubscription;
  identityTheftMonitoringSubscriptionAuthentication: operations.IdentityTheftMonitoringSubscriptionAuthentication;
  identityTheftProtectionFamily: operations.IdentityTheftProtectionFamily;
  internalPortal: operations.InternalPortal;
  iosVersion: operations.IosVersion;
  license: operations.LicenseOperations;
  location: operations.Location;
  maintenance: operations.Maintenance;
  notifications: operations.NotificationsOperations;
  notificationSettings: operations.NotificationSettings;
  oneTimeCyberAgentScan: operations.OneTimeCyberAgentScan;
  oneTimeCyberAgentScanEmailVerification: operations.OneTimeCyberAgentScanEmailVerification;
  pendingNotifications: operations.PendingNotifications;
  phoneVerification: operations.PhoneVerification;
  protectionStatus: operations.ProtectionStatus;
  recommendations: operations.Recommendations;
  rewardActivities: operations.RewardActivities;
  secureConnection: operations.SecureConnection;
  secureConnectionSettings: operations.SecureConnectionSettings;
  sendAppDownloadLink: operations.SendAppDownloadLink;
  settings: operations.Settings;
  sharedDeviceProtectionStatus: operations.SharedDeviceProtectionStatus;
  sharedDevices: operations.SharedDevices;
  testNotifications: operations.TestNotifications;
  trustedNetwork: operations.TrustedNetworkOperations;
  unauthNotificationSettings: operations.UnauthNotificationSettings;
  unauthOneTimeCyberAgentScan: operations.UnauthOneTimeCyberAgentScan;
  unauthOneTimeCyberAgentScanEmailVerification: operations.UnauthOneTimeCyberAgentScanEmailVerification;
  userProfile: operations.UserProfileOperations;
  values: operations.Values;
  vpn: operations.Vpn;

  /**
   * Initializes a new instance of the MicrosoftConsumerSecurityClient class.
   * @param credentials Subscription credentials which uniquely identify client subscription.
   * @param [options] The parameter options
   */
  constructor(credentials: coreHttp.TokenCredential | coreHttp.ServiceClientCredentials, options?: Models.MicrosoftConsumerSecurityClientOptions) {
    super(credentials, options);
    this.alerts = new operations.Alerts(this);
    this.apiVersions = new operations.ApiVersions(this);
    this.associatedDevices = new operations.AssociatedDevices(this);
    this.betaEnrollment = new operations.BetaEnrollment(this);
    this.breaches = new operations.Breaches(this);
    this.chat = new operations.Chat(this);
    this.credit = new operations.Credit(this);
    this.deviceProtectionHistory = new operations.DeviceProtectionHistory(this);
    this.devices = new operations.Devices(this);
    this.downloads = new operations.Downloads(this);
    this.emailVerification = new operations.EmailVerification(this);
    this.eol = new operations.Eol(this);
    this.familyBreaches = new operations.FamilyBreaches(this);
    this.familyCredit = new operations.FamilyCredit(this);
    this.familyEmailVerification = new operations.FamilyEmailVerification(this);
    this.familyIdentityTheftMonitoringSubscription = new operations.FamilyIdentityTheftMonitoringSubscription(this);
    this.familyIdentityTheftMonitoringSubscriptionAuthentication = new operations.FamilyIdentityTheftMonitoringSubscriptionAuthentication(this);
    this.familyInvitations = new operations.FamilyInvitations(this);
    this.familyMembers = new operations.FamilyMembers(this);
    this.familyPermissions = new operations.FamilyPermissions(this);
    this.familyPhoneVerification = new operations.FamilyPhoneVerification(this);
    this.familyUser = new operations.FamilyUser(this);
    this.identityTheftMonitoringSubscription = new operations.IdentityTheftMonitoringSubscription(this);
    this.identityTheftMonitoringSubscriptionAuthentication = new operations.IdentityTheftMonitoringSubscriptionAuthentication(this);
    this.identityTheftProtectionFamily = new operations.IdentityTheftProtectionFamily(this);
    this.internalPortal = new operations.InternalPortal(this);
    this.iosVersion = new operations.IosVersion(this);
    this.license = new operations.LicenseOperations(this);
    this.location = new operations.Location(this);
    this.maintenance = new operations.Maintenance(this);
    this.notifications = new operations.NotificationsOperations(this);
    this.notificationSettings = new operations.NotificationSettings(this);
    this.oneTimeCyberAgentScan = new operations.OneTimeCyberAgentScan(this);
    this.oneTimeCyberAgentScanEmailVerification = new operations.OneTimeCyberAgentScanEmailVerification(this);
    this.pendingNotifications = new operations.PendingNotifications(this);
    this.phoneVerification = new operations.PhoneVerification(this);
    this.protectionStatus = new operations.ProtectionStatus(this);
    this.recommendations = new operations.Recommendations(this);
    this.rewardActivities = new operations.RewardActivities(this);
    this.secureConnection = new operations.SecureConnection(this);
    this.secureConnectionSettings = new operations.SecureConnectionSettings(this);
    this.sendAppDownloadLink = new operations.SendAppDownloadLink(this);
    this.settings = new operations.Settings(this);
    this.sharedDeviceProtectionStatus = new operations.SharedDeviceProtectionStatus(this);
    this.sharedDevices = new operations.SharedDevices(this);
    this.testNotifications = new operations.TestNotifications(this);
    this.trustedNetwork = new operations.TrustedNetworkOperations(this);
    this.unauthNotificationSettings = new operations.UnauthNotificationSettings(this);
    this.unauthOneTimeCyberAgentScan = new operations.UnauthOneTimeCyberAgentScan(this);
    this.unauthOneTimeCyberAgentScanEmailVerification = new operations.UnauthOneTimeCyberAgentScanEmailVerification(this);
    this.userProfile = new operations.UserProfileOperations(this);
    this.values = new operations.Values(this);
    this.vpn = new operations.Vpn(this);
  }
}

// Operation Specifications

export {
  MicrosoftConsumerSecurityClient,
  MicrosoftConsumerSecurityClientContext,
  Models as MicrosoftConsumerSecurityModels,
  Mappers as MicrosoftConsumerSecurityMappers
};
export * from "./operations";
